import { notify, TYPE } from "@8x8/oxygen-toaster";

/**
 * Notify the user of an operations' success with a toast message.
 * This function takes in the result from RQ itself, then checks its status.
 *
 * @param {object} result - Redux Query result object
 * @param {object} options
 */
export const popToastOnSuccess = (result, options) => {
  const message = options?.message ?? "Operation successful.";
  if (result?.isSuccess) {
    notify({
      content: message,
      type: TYPE.success,
    });
  }
};
